<template>
  <b-container>
    <b-form v-on:submit.prevent>
      <b-row>
        <b-col cols="8">
          <b-card>
            <b-row>
              <b-col class="mb-2">
                <b-badge :variant="statusVariant(form.status)">
                  <span v-if="form.status === 1">{{ form.status_name }}</span>
                  <span v-else-if="form.status === 2">{{
                    form.status_name
                  }}</span>
                </b-badge>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Item" label-for="asset_item">
                  <v-select
                    id="asset_item"
                    v-model="form.selectedItem"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsItem"
                    placeholder="Select 1 Item"
                    disabled
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedItem"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedItem }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Qty" label-for="qty">
                  <b-form-input
                    id="qty"
                    type="number"
                    placeholder="Qty"
                    v-model="form.qty"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Origin" label-for="origin">
                  <v-select
                    id="origin"
                    v-model="form.selectedOrigin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsOrigin"
                    placeholder="Select 1 Origin"
                    disabled
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedOrigin"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedOrigin }}</strong> -->
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Destination" label-for="destination">
                  <v-select
                    id="destination"
                    v-model="form.selectedDestination"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsDestination"
                    placeholder="Select 1 Destination"
                    disabled
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedDestination"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <!-- Selected: <strong>{{ form.selectedDestination }}</strong> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Description" label-for="description">
                  <b-form-textarea
                    id="description"
                    placeholder="Description"
                    v-model="form.description"
                    required
                    :disabled="form.status === 1 ? false : true"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="form.status === 1">
              <!-- submit and reset -->
              <b-col class="mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  block
                  @click="validation()"
                >
                  Update
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card>
            <b-form-group
              :state="errors"
              label="Photo Origin"
              label-for="photo_origin"
              invalid-feedback="Photo Origin is required"
            >
              <b-img
                id="photoURL"
                :src="photo"
                fluid
                alt="origin photo"
                class="mb-1"
                v-if="(hasImage === '') | null"
              />
              <b-form-group
                :state="errors"
                label="Photo Destination"
                label-for="photo_destination"
                invalid-feedback="Photo Destination is required"
              >
                <b-img
                  id="photoURL2"
                  :src="photo2"
                  fluid
                  alt="destination photo"
                  class="mb-1"
                  v-if="form.status === 2"
                />
                <validation-provider
                  #default="{ errors }"
                  name="photo_destination"
                  rules="required"
                  v-if="form.status === 1"
                >
                  <image-uploader
                    id="photoDestination"
                    :preview="true"
                    :className="[
                      'fileinput',
                      { 'fileinput--loaded': hasImage2 },
                    ]"
                    :debug="0"
                    :autoRotate="true"
                    accept="image/*"
                    doNotResize="['gif', 'svg']"
                    outputFormat="string"
                    @input="setImage2"
                  ></image-uploader>
                  <small class="text-danger">{{
                    errors[0] || errMessageImage
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {
  BBadge,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormTextarea,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Cleave from "vue-cleave-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";

export default {
  components: {
    ImageUploader,
    Cleave,
    flatPickr,
    ToastificationContent,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BBadge,
    BImg,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        status: null,
        status_name: "",
        selectedItem: null,
        optionsItem: [],
        qty: null,
        description: "",
        selectedOrigin: null,
        optionsOrigin: [],
        selectedDestination: null,
        optionsDestination: [],
      },
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      hasImage: "",
      image: "",
      photo: "",
      hasImage2: "",
      image2: "",
      photo2: "",
      errors: "",
      errMessage: "",
      errMessageImage: "",
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        1: "light-warning",
        2: "light-success",
      };

      return (status) => statusColor[status];
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getDetails();
    this.getAssetItem();
    this.getLocation();
  },
  methods: {
    setImage: function (file) {
      this.hasImage = true;
      this.image = file;
    },
    setImage2: function (file) {
      this.hasImage2 = true;
      this.image2 = file;
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("asset/movement/" + id).then((response) => {
        // console.log(response.data.data)
        this.form.status = response.data.data.status;
        this.form.status_name = response.data.data.status_name;
        this.form.selectedItem = {
          value: response.data.data.asset_id,
          text: response.data.data.asset_name,
        };
        this.form.qty = response.data.data.qty;
        this.form.description = response.data.data.description;
        this.form.selectedOrigin = {
          value: response.data.data.origin,
          text: response.data.data.origin_name,
        };
        this.form.selectedDestination = {
          value: response.data.data.destination,
          text: response.data.data.destination_name,
        };
        const { baseUrl } = $themeConfig.app;
        this.photo = baseUrl;
        this.photo += "storage/movement/";
        this.photo += response.data.data.image_origin;
        this.image = this.getBase64Image(document.getElementById("photoURL"));
        this.photo2 = baseUrl;
        this.photo2 += "storage/movement/";
        this.photo2 += response.data.data.image_destination;
        this.image2 = this.getBase64Image(document.getElementById("photoURL2"));
      });
    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      this.image = canvas.toDataURL("image/png");
      this.image += this.image.replace(/^data:image\/(png|jpg);base64,/, "");
      // console.log(this.image)
    },
    getAssetItem() {
      this.$http.get("asset/items").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          // console.log(datas[1].children.length === 0)
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsItem.push($data);
        }
        // console.log(this.form.optionsItem)
      });
    },
    getLocation() {
      this.$http.get("asset/locations").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          // console.log(datas[1].children.length === 0)
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsOrigin.push($data);
          this.form.optionsDestination.push($data);
        }
        // console.log(this.form.optionsOrigin)
        // console.log(this.form.optionsDestination)
      });
    },
    validation() {
      if (this.form.description === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Description field is required",
            variant: "warning",
          },
        });
      } else if (this.image2 === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Photo Destination field is required",
            variant: "warning",
          },
        });
      } else {
        this.updateAssetMovement();
      }
    },
    updateAssetMovement() {
      const id = this.$route.params.id;
      this.$http
        .post("asset/movement/" + id + "/update", {
          description: this.form.description,
          image_destination: this.image2,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success update Asset Movement",
              variant: "success",
            },
          });
          location.href = "/asset/asset-movement";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style>
img.img-preview {
  width: 100%;
  margin-bottom: 15px;
}
</style>